import * as _ from "lodash";

export class Street {
    public haddress: string;
    public hcity: string;
    public hstate: string;

    constructor(streetData?: object) {
        if (streetData) {
            this.setData(streetData);
        }
    }

    setData(streetData: object): void {
        _.merge(this, streetData);
    }

    getID(): string {
        return this.haddress + "," + this.hcity + "," + this.hstate;
    }
}
